import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

const dataInputRoute = 'finance';
@Injectable()
export class FinanceNavigation {

  constructor
    (
      private readonly route: ActivatedRoute
    ) { }
  financeSubMenu =
    

      {
        sectionName: 'Annual Delivery Plan',
        description: ``,
        state: null,
        icon: 'bar_chart',
        menuItems: [
          {
            name: 'Annual Delivery Plan',
            featureId: [247],
            description: ``,
            state: null,
            icon: null,
            submenu: [
              {
                name: 'Accredited Qualifications',
                featureId: [236],
                description: ``,
                state: `${dataInputRoute}/accredited-qualifications`,
                icon: null
              },
              {
                name: 'Service Lines',
                featureId: [238],
                description: ``,
                state: `${dataInputRoute}/service-lines`,
                icon: null
              },
              {
                name: 'Unaccredited Qualifications',
                featureId: [237],
                description: ``,
                state: `${dataInputRoute}/unaccredited-qualifications`,
                icon: null
              },
              {
                name: 'Fixed Cost',
                featureId: [269],
                description: ``,
                state: `${dataInputRoute}/fixed-cost`,
                icon: null
              },
            ]
          },
          {
            name: 'Quality Assurance',
            featureId: [239],
            description: ``,
            state: null,
            icon: null,
            submenu: [
              {
                name: 'Screening & Assessment',
                featureId: [239],
                description: ``,
                state: `${dataInputRoute}/financial-year-quality-assurance`,
                icon: null
              },]
          },
          {
            name: 'Reports',
            featureId: [265],
            description: ``,
            state: null,
            icon: null,
            submenu: [
              {
                name: 'Payment Mechanism',
                featureId: [265],
                description: ``,
                state: `${dataInputRoute}/payment-mechanism`,
                icon: null
              },
              {
                name: 'Paymech Reconciliation',
                featureId: [265],
                description: ``,
                state: `${dataInputRoute}/paymech-reconcilation`,
                icon: null
              },
              {              
                name: 'Paymech LDH',
                featureId: [265],
                description: ``,
                state: `${dataInputRoute}/paymech-ldh`,
                icon: null
              }
            ]
          },
        ]
      };
    
}
